/**
 * Gemstone Page — Unified Script
 * Handles: filters, detail panel, modal, cart
 */

document.addEventListener('DOMContentLoaded', () => {

  // ═══════════════════════════════════════════
  // STATE
  // ═══════════════════════════════════════════

  const state = {
    selectedShape : '',
    selectedColor : '',
    maxCarat      : 15,
    maxPrice      : 2000,
  };

  // ═══════════════════════════════════════════
  // ELEMENT REFERENCES
  // ═══════════════════════════════════════════

  const cards        = document.querySelectorAll('.gemstone-card');
  const counter      = document.getElementById('gemstone-count');
  const caratRange   = document.getElementById('carat-range');
  const priceRange   = document.getElementById('price-range');
  const caratValue   = document.getElementById('carat-value');
  const priceValue   = document.getElementById('price-value');
  const clearBtn     = document.getElementById('clear-filters');
  const detailPanel  = document.getElementById('gemstone-detail-panel');
  const modal        = document.getElementById('gemstone-modal');
  const modalContent = document.getElementById('gemstone-modal-content');
  const modalClose   = document.querySelector('.gemstone-modal-close');

  // ═══════════════════════════════════════════
  // FILTERS
  // ═══════════════════════════════════════════

  function applyFilters() {
    cards.forEach(card => {
      const shape = (card.dataset.shape || '').trim();
      const color = (card.dataset.color || '').trim();
      const carat = parseFloat(card.dataset.carat  || 0);
      const price = parseFloat(card.dataset.price  || 0);

      const visible =
        (!state.selectedShape || shape === state.selectedShape) &&
        (!state.selectedColor || color === state.selectedColor) &&
        carat <= state.maxCarat &&
        price <= state.maxPrice;

      card.style.display = visible ? '' : 'none';
    });

    updateCount();
  }

  function updateCount() {
    if (!counter) return;
    const visible = document.querySelectorAll(
      '.gemstone-card:not([style*="display: none"])'
    ).length;
    counter.textContent = visible;
  }

  function resetFilters() {
    state.selectedShape = '';
    state.selectedColor = '';
    state.maxCarat      = 15;
    state.maxPrice      = 2000;

    document.querySelectorAll('.shape-option, .color-option')
      .forEach(el => el.classList.remove('active'));

    if (caratRange)  caratRange.value       = 15;
    if (priceRange)  priceRange.value       = 2000;
    if (caratValue)  caratValue.textContent = '15 ct';
    if (priceValue)  priceValue.textContent = '$2000';

    applyFilters();
  }

  // ── Shape filter ──
  document.querySelectorAll('.shape-option').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.shape-option')
        .forEach(el => el.classList.remove('active'));
      btn.classList.add('active');
      state.selectedShape = btn.dataset.shape;
      applyFilters();
    });
  });

  // ── Color filter ──
  document.querySelectorAll('.color-option').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.color-option')
        .forEach(el => el.classList.remove('active'));
      btn.classList.add('active');
      state.selectedColor = btn.dataset.color;
      applyFilters();
    });
  });

  // ── Carat range ──
  if (caratRange) {
    caratRange.addEventListener('input', function () {
      state.maxCarat = parseFloat(this.value);
      if (caratValue) caratValue.textContent = this.value + ' ct';
      applyFilters();
    });
  }

  // ── Price range ──
  if (priceRange) {
    priceRange.addEventListener('input', function () {
      state.maxPrice = parseFloat(this.value);
      if (priceValue) priceValue.textContent = '$' + this.value;
      applyFilters();
    });
  }

  // ── Clear all filters ──
  if (clearBtn) {
    clearBtn.addEventListener('click', resetFilters);
  }

  // ── Initial run ──
  applyFilters();

  // ═══════════════════════════════════════════
  // ADD TO RING — saves handle, goes to builder
  // ═══════════════════════════════════════════

  function bindAddToRingButtons(container) {
    (container || document).querySelectorAll('.add-ring-btn').forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (this.dataset.productHandle) {
          localStorage.setItem(
            'selectedGemstoneHandle',
            this.dataset.productHandle
          );
        }
        window.location.href = this.href || '/pages/custom-ring-builder';
      });
    });
  }

  bindAddToRingButtons();

  // ═══════════════════════════════════════════
  // ADD TO CART — shared fetch helper
  // ═══════════════════════════════════════════

  function addToCart(variantId, btn) {
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method  : 'POST',
      headers : { 'Content-Type': 'application/json' },
      body    : JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled    = false;
      }, 2000);
    })
    .catch(() => {
      btn.textContent = 'Error — try again';
      btn.disabled    = false;
    });
  }


  // ═══════════════════════════════════════════
  // MODAL
  // ═══════════════════════════════════════════

  function buildModalHTML(card) {
    const mediaHTML = `
<div class="gemstone-media-wrapper">

  <div class="gemstone-media-toolbar">

    <button class="media-toggle active" data-type="image">
      🖼 Image
    </button>

    ${
      card.dataset.video
      ? `
      <button class="media-toggle" data-type="video">
        ▶ Video
      </button>
      `
      : ''
    }

  </div>

  <div class="media-view image-view active">

    <img
      src="${card.dataset.image}"
      alt="${card.dataset.displayTitle}"
    >

  </div>

  ${
    card.dataset.video
    ? `
    <div class="media-view video-view">

      <iframe
        src="${card.dataset.video}"
        width="100%"
        height="500"
        frameborder="0"
        loading="lazy">
      </iframe>

    </div>
    `
    : ''
  }

</div>
`;

    return `
      <div class="gemstone-modal-layout">
        <div class="gemstone-modal-image">
          ${mediaHTML}
        </div>
        <div class="gemstone-modal-info">
          <h2>${card.dataset.displayTitle || ''}</h2>
          <div class="gemstone-modal-price">${card.dataset.displayPrice || ''}</div>
          <div class="gemstone-modal-specs">${card.dataset.description || ''}</div>
          <div class="gemstone-modal-buttons">
            <button
              class="modal-add-cart"
              data-variant-id="${card.dataset.variantId || ''}">
              ADD TO CART
            </button>
            <a href="${card.dataset.builder || '#'}" class="add-ring-btn">
              ADD TO RING
            </a>
          </div>
        </div>
      </div>
    `;
  }

  if (modal && modalContent) {

    document.querySelectorAll('.view-btn').forEach(button => {
      button.addEventListener('click', () => {
        const card = button.closest('.gemstone-card');
        modalContent.innerHTML = buildModalHTML(card);
modal.classList.add('active');

const toggles =
  modalContent.querySelectorAll('.media-toggle');

toggles.forEach(btn => {

  btn.addEventListener('click', () => {

    modalContent
      .querySelectorAll('.media-toggle')
      .forEach(b => b.classList.remove('active'));

    btn.classList.add('active');

    const imageView =
      modalContent.querySelector('.image-view');

    const videoView =
      modalContent.querySelector('.video-view');

    if(btn.dataset.type === 'image'){

      imageView.classList.add('active');

      if(videoView){
        videoView.classList.remove('active');
      }

    } else {

      imageView.classList.remove('active');

      if(videoView){
        videoView.classList.add('active');
      }

    }

  });

});

        // Cart button inside modal
        const cartBtn = modalContent.querySelector('.modal-add-cart');
        if (cartBtn) {
          cartBtn.addEventListener('click', () => {
            addToCart(cartBtn.dataset.variantId, cartBtn);
          });
        }

        // Add to ring inside modal
        bindAddToRingButtons(modalContent);
      });
    });

    // Close modal
    if (modalClose) {
      modalClose.addEventListener('click', () => {
        modal.classList.remove('active');
      });
    }

    // Click outside to close
    modal.addEventListener('click', e => {
      if (e.target === modal) modal.classList.remove('active');
    });
    

    // ESC key to close
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') modal.classList.remove('active');
    });
  }

});